import useSWR from 'swr';

import keycloakService from '../../../../keycloak_service';

import { postToSinatra } from '../../../../utils/api_utils';
import orderBy from 'lodash/orderBy';
import parseISO from 'date-fns/parseISO';

export const fetchModelVersions = ([model_id, workspace_id]) => {
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify({
      model_id,
      workspace_id
    }),
  };

  return postToSinatra('v1/api/models/list_versions_for_model', fetchOptions)
}

export const useListModelVersions = (model_id, workspace_id) => {
  const {
    data,
    error,
    isLoading,
  } = useSWR([model_id, workspace_id, 'admin-model-versions-list'], fetchModelVersions, {
    refreshInterval: 10000,
    loadingTimeout: 1000,
  });

  const sortedVersions = orderBy(data?.model_versions, ({ model_version }) => {
    return model_version?.created_at ? parseISO(model_version?.created_at).getTime() : 0;
  }, 'desc');

  return {
    data: sortedVersions,
    error,
    isLoading,
  }
}

export default useListModelVersions;
